// extracted by mini-css-extract-plugin
module.exports = {"rootTouchBuffer":"Handle_rootTouchBuffer__2ybtU","visibleHandle":"Handle_visibleHandle__1boW-","dragged":"Handle_dragged__a0DNB"};